import { useState, useCallback } from 'react'
import axios from 'src/utilities/http-client'

interface QuizChoice {
  text: string
}

interface QuizExplanation {
  text: string
}

export interface QuizDataItem {
  questionText: string
  choices?: QuizChoice[]
  explanations?: QuizExplanation[]
}

interface UseOldQuizDataReturn {
  quizData: QuizDataItem[]
  isLoading: boolean
  error: string | null
  fetchQuizData: (eventName: string) => Promise<void>
}

export function useOldQuizData(): UseOldQuizDataReturn {
  let [quizData, setQuizData] = useState<QuizDataItem[]>([])
  let [isLoading, setIsLoading] = useState(false)
  let [error, setError] = useState<string | null>(null)

  let fetchQuizData = useCallback(async (eventName: string) => {
    setIsLoading(true)
    setError(null)

    try {
      let response = await axios.get(
        `/api/pipeline/planning/events/quiz-data/${encodeURIComponent(eventName)}`,
      )
      setQuizData(response.data)
    } catch (err) {
      let errorMessage =
        err instanceof Error ? err.message : 'Failed to fetch quiz data'
      setError(errorMessage)
      setQuizData([])
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    quizData,
    isLoading,
    error,
    fetchQuizData,
  }
}
